import { Chip } from '@mui/material';
import { getStatusStyles } from 'src/utils/utils';

const StatusChip = ({ status }) => {
    return (
        <Chip
            label={status}
            variant="outlined"
            sx={{
                height: '24px',
                borderWidth: 1,
                fontWeight: 500,
                fontSize: '0.75rem',
                '& .MuiChip-label': {
                    padding: '0 8px',
                },
                ...getStatusStyles(status),
            }}
        />
    );
};

export default StatusChip;
